import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 24, filter: "blur(8px)" },
  whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      {...fadeUp}
      transition={{ ...fadeUp.transition, delay }}
      className={className}
    >
      {children}
    </Comp>
  );
}

export function Eyebrow({ children, color = "red", className = "" }) {
  const c = color === "green" ? "text-[#1A4331]" : "text-[#A6192E]";
  return (
    <span
      className={`text-xs sm:text-sm font-semibold tracking-[0.22em] uppercase ${c} ${className}`}
    >
      {children}
    </span>
  );
}

export function SectionHead({ eyebrow, title, lead, color, align = "left" }) {
  const a = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${a} gap-5 max-w-3xl`}>
      {eyebrow && <Eyebrow color={color}>{eyebrow}</Eyebrow>}
      <motion.h2
        {...fadeUp}
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.05] text-[#1A1A1A]"
      >
        {title}
      </motion.h2>
      {lead && (
        <motion.p
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.1 }}
          className="text-base sm:text-lg text-[#4A4D4A] leading-relaxed max-w-2xl"
        >
          {lead}
        </motion.p>
      )}
    </div>
  );
}
